<template>
    <div>
        <!-- Header Start -->
        <div style="margin-bottom: 24px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;" class="flex-wrap">
            <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0; color: #111827;">QR Distribution Monitoring</h2>
        </div>
        <!-- Header End -->

        <!-- Distribution Overview Start -->
        <div class="bg-white rounded shadow-sm mb-4" style="padding: 20px">
            <h3 class="h5 font-weight-semibold" style="color: #2F2F2F; margin-bottom: 20px;">Distribution Overview</h3>
            <div class="row stats-row">
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/saldo-awal.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">Saldo Awal</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && data.stats.qty_before !== undefined ? numberWithCommas(data.stats.qty_before) : '1.500' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/in-transit-dealer.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">In-Transit Dealer</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && (data.stats.qty_dealer_intransit !== undefined || data.stats.qty_intransit !== undefined) ? numberWithCommas(data.stats.qty_dealer_intransit || data.stats.qty_intransit) : '12.000' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/diterima-md.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">Diterima Dealer</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && (data.stats.qty_dealer_received !== undefined || data.stats.qty_received !== undefined) ? numberWithCommas(data.stats.qty_dealer_received || data.stats.qty_received) : '7.350' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/diterima-dealer.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">QR Dipakai</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && data.stats.qty_mapping !== undefined ? numberWithCommas(data.stats.qty_mapping) : '7.350' }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/saldo-akhir.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 14px; color: #4B5563;">Saldo Akhir</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0; color: #111827;">{{ data.stats && data.stats.qty_after !== undefined ? numberWithCommas(data.stats.qty_after) : '3.000' }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Distribution Overview End -->

        <!-- Detail Pengiriman Start -->
        <delivery-detail-table></delivery-detail-table>
        <!-- Detail Pengiriman End -->

        <!-- QR Distribution Summary Start -->
        <distribution-summary-table></distribution-summary-table>
        <!-- QR Distribution Summary End -->

        <!-- Detail Mapping QR Code Start -->
        <mapping-detail-table></mapping-detail-table>
        <!-- Detail Mapping QR Code End -->
    </div>
</template>

<script>
import moment from 'moment';

import deliveryDetailTable from './children/deliveryDetailTable.vue';
import distributionSummaryTable from './children/distributionSummaryTable.vue';
import mappingDetailTable from './children/mappingDetailTable.vue';

export default {
    metaInfo: {
        title: 'Distribution Monitoring'
    },
    data() {
        return {
            moment: moment,
            data: {
                stats: null,
            }
        };
    },
    components: {
        deliveryDetailTable,
        distributionSummaryTable,
        mappingDetailTable,
    },
    beforeMount() {
        const contentEl = document.getElementById('content');
        if (contentEl) {
            contentEl.style.background = '#F8F8F8';
        }
    },
    beforeDestroy() {
        const contentEl = document.getElementById('content');
        if (contentEl) {
            contentEl.style.background = '';
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.$http.get(`/api/qrs/highlight`)
                .then((resp) => {
                    this.data.stats = resp.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }
};
</script>

<style>
.qtrust-select {
    min-height: 0;
}

.qtrust-select .multiselect__tags {
    min-height: 0;
    height: 32px;
    padding: 4px 40px 0 8px;
    border-color: #E2E8F0;
    border-radius: 4px;
}

.qtrust-select .multiselect__tags .multiselect__placeholder {
    margin: 0;
    padding: 0;
    font-size: 13px;
    color: #4B5563;
}

.qtrust-select .multiselect__select {
    height: 32px;
}

.qtrust-select .multiselect__select::before {
    z-index: 1;
    margin: 0;
}

.qtrust-select .multiselect__single {
    margin: 0;
    font-size: 13px;
    color: #1F2937;
}
</style>

<style scoped>
.stats-row {
    padding: 5px 0 5px;
}
.stats-row .col-md:not(:first-child) {
    border-left: 1px solid #ECECEC;
}
</style>